import { computed, reactive } from 'vue'
import {
  MAX_DIAGNOSE_TAGS,
  buildModifyPayload,
  complianceOptions,
  createPortraitForm,
  getDiagnosisDefaultTagsByDict,
  getDictOptions,
  marriageOptions,
  normalizeDiagnoseFields,
  syncPortraitForm
} from '../model/portraitForm'

export function useEditPortraitForm(getPortraitDict = () => []) {
  const form = reactive(createPortraitForm())

  const diagnosisDefaultTags = computed(() => {
    if (Array.isArray(form.basic.diagnosisDefaultTags) && form.basic.diagnosisDefaultTags.length) {
      return form.basic.diagnosisDefaultTags
    }
    return getDiagnosisDefaultTagsByDict(getPortraitDict)
  })

  const emotionOptions = computed(() => getDictOptions(getPortraitDict, 'emotion_state'))
  const responseOptions = computed(() => getDictOptions(getPortraitDict, 'response_pattern'))
  const contactOptions = computed(() => getDictOptions(getPortraitDict, 'contact_preference'))
  const cooperationOptions = computed(() =>
    getDictOptions(getPortraitDict, 'communication_compliance')
  )

  const syncForm = data => syncPortraitForm(form, data)
  const createModifyPayload = initialData => buildModifyPayload(form, initialData)

  const toggleDiagnoseTag = tag => {
    const index = form.basic.diagnosisTags.indexOf(tag)
    if (index > -1) {
      form.basic.diagnosisTags.splice(index, 1)
      return
    }

    const hasRemark = Boolean((form.basic.diagnosisManualTags || '').trim())
    if (form.basic.diagnosisTags.length >= MAX_DIAGNOSE_TAGS) return
    if (hasRemark && form.basic.diagnosisTags.length >= 1) return

    form.basic.diagnosisTags.push(tag)
    normalizeDiagnoseFields(form.basic)
  }

  const setDiagnoseRemark = value => {
    if (form.basic.diagnosisTags.length >= MAX_DIAGNOSE_TAGS) {
      form.basic.diagnosisManualTags = ''
      return
    }
    form.basic.diagnosisManualTags = value
    normalizeDiagnoseFields(form.basic)
  }

  return {
    form,
    marriageOptions,
    complianceOptions,
    diagnosisDefaultTags,
    emotionOptions,
    responseOptions,
    contactOptions,
    cooperationOptions,
    syncForm,
    createModifyPayload,
    toggleDiagnoseTag,
    setDiagnoseRemark
  }
}
